import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";

const IoArrowBack = require("react-icons/io5").IoArrowBack;

const kategoriWebOptions = ["Nasional", "Internasional", "Ekonomi", "Teknologi"];
const kategoriOptions = ["analisis", "opini"];

const EditorialDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);

  const [judul, setJudul] = useState("");
  const [kategori, setKategori] = useState("");
  const [kategoriWeb, setKategoriWeb] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [gambar, setGambar] = useState<File | null>(null);

  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  /* ================= FETCH DETAIL ================= */
  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/editorial/${id}`);

        const editorial = res.data.data;

        setData(editorial);

        setJudul(editorial.judul);
        setKategori(editorial.kategori);
        setKategoriWeb(editorial.kategori_web);
        setDeskripsi(editorial.deskripsi);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal memuat data editorial",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [id]);

  /* ================= UPDATE ================= */
  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    Swal.fire({
      title: "Menyimpan...",
      text: "Mohon tunggu",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("kategori", kategori);
    formData.append("kategori_web", kategoriWeb);
    formData.append("deskripsi", deskripsi);

    if (gambar) formData.append("gambar", gambar);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/editorial/${id}?_method=PUT`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Editorial berhasil diperbarui",
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/dashboard/editorial");
      }, 1500);
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: err?.response?.data?.message || "Terjadi kesalahan saat update editorial",
      });
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    const confirm = await Swal.fire({
      title: "Yakin?",
      text: "Editorial akan dihapus permanen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Ya, hapus",
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
      title: "Menghapus...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/editorial/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: "Terhapus",
        text: "Editorial berhasil dihapus",
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/dashboard/editorial");
      }, 1500);
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: err?.response?.data?.message || "Gagal menghapus editorial",
      });
    }
  };

  if (loading) return <div className="p-4">Memuat...</div>;
  if (!data) return <div className="p-4 text-red-500">Data tidak ditemukan</div>;

  return (
    <div className="p-4 max-w-3xl mx-auto bg-white rounded shadow">
      <Link to="/dashboard/editorial">
        <div className="flex items-center gap-3 mb-4 cursor-pointer">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Edit Editorial</h1>
        </div>
      </Link>

      <form onSubmit={handleUpdate} className="space-y-4">
        <div>
          <label className="font-semibold">Judul</label>
          <input type="text" value={judul} onChange={(e) => setJudul(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="font-semibold">Kategori</label>
          <select value={kategori} onChange={(e) => setKategori(e.target.value)} className="w-full border px-3 py-2 rounded bg-white">
            <option value="">-- Pilih Kategori --</option>
            {kategoriOptions.map((item) => (
              <option key={item}>{item}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="font-semibold">Kategori Web</label>
          <select value={kategoriWeb} onChange={(e) => setKategoriWeb(e.target.value)} className="w-full border px-3 py-2 rounded bg-white">
            <option value="">-- Pilih Kategori Web --</option>
            {kategoriWebOptions.map((item) => (
              <option key={item}>{item}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="font-semibold">Deskripsi</label>
          <ReactQuill theme="snow" value={deskripsi} onChange={setDeskripsi} />
        </div>

        <div>
          <label className="font-semibold">Gambar</label>
          <input type="file" onChange={(e) => setGambar(e.target.files?.[0] || null)} className="w-full border px-3 py-2 rounded bg-white" />
        </div>

        {data.gambar && <img src={`https://base.bkpeduli.com/${data.gambar}`} alt={data.judul} className="w-48 rounded" />}

        <div className="text-sm text-gray-500">Views: {data.views}</div>

        <div className="flex gap-3">
          <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">
            Simpan Perubahan
          </button>

          <button type="button" onClick={handleDelete} className="bg-red-600 text-white px-4 py-2 rounded">
            Hapus
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditorialDetail;
